import { combineReducers, configureStore } from '@reduxjs/toolkit';
import CustomizerReducer from './customizer/CustomizerSlice';

// Auth
import authReducer from './apps/login/LoginSlice';
// Plan
import planReducer from './apps/plan/PlanSlice';
// Permission
import permissionReducer from './apps/permission/PermissionSlice';
// Helper
import helperReducer from './apps/helper/HelperSlice';
// Shop
import shopReducer from './apps/shop/ShopSlice';
// Corporation
import corporationReducer from './apps/corporation/CorporationSlice';
// Vehicle Type
import vehicleTypeReducer from './apps/vehicle-type/VehicleTypeSlice';
// Role
import roleReducer from './apps/roles/RoleSlice';
// Country
import countryReducer from './apps/country/CountrySlice';
// State
import stateReducer from './apps/state/StateSlice';
// User
import userReducer from './apps/users/UserSlice';
// City
import cityReducer from './apps/city/CitySlice';
// Category
import categoryReducer from './apps/category/CategorySlice';
// Sub Category
import subCategoryReducer from './apps/subCategory/SubCategorySlice';
// Designation
import designationReducer from './apps/designation/DesignationSlice';
// Particular
import particularReducer from './apps/particular/ParticularSlice';
// Site
import siteReducer from './apps/site/SiteSlice';
// Department
import departmentReducer from './apps/department/DepartmentSlice';
// Site Department
import siteDepartmentReducer from './apps/siteDepartment/SiteDepartmentSlice';

const appReducer = combineReducers({
  customizer: CustomizerReducer,
  auth: authReducer,
  plan: planReducer,
  permission: permissionReducer,
  helper: helperReducer,
  shop: shopReducer,
  corporation: corporationReducer,
  vehicleType: vehicleTypeReducer,
  role: roleReducer,
  country: countryReducer,
  state: stateReducer,
  user: userReducer,
  city: cityReducer,
  category: categoryReducer,
  subCategory: subCategoryReducer,
  designation: designationReducer,
  particular: particularReducer,
  site: siteReducer,
  department: departmentReducer,
  siteDepartment: siteDepartmentReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'auth/logout') {
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
});

export default store;

